export const challenge = {
  ssn: 'Provide your U.S. Social Security Number',
  dob: 'What is your date of birth?',
  submit: 'Submit',
  errorTitle: 'Sorry, but we couldn’t verify your information!',
  errorMessage: 'The U.S. Social Security Number or date of birth provided was incorrect.',
};
